import { ArrowPathIcon } from '@heroicons/react/24/outline';
import React from 'react';

const HoldReportSearchBarCP = ({ value, onChange, onSearch, onReset, loading = false, placeholder = 'Enter a search term' }) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSearch?.();
    }
  };

  return (
    <div className="relative rounded-md shadow-sm flex-grow">
      <input
        type="text"
        name="search"
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        className="block w-full pl-7 pr-24 sm:text-sm border-gray-300 rounded-md"
        placeholder={placeholder}
        aria-label="Search"
      />

      <button
        onClick={onSearch}
        disabled={!value || loading}
        className={`absolute right-24 top-0 bottom-0 text-white px-3 py-2 ${
          !value || loading ? 'bg-gray-500 cursor-not-allowed' : 'bg-green-600 hover:bg-green-700'
        }`}
      >
        {loading ? 'Searching…' : 'Search'}
      </button>

      <button
        onClick={onReset}
        className="absolute right-0 top-0 bottom-0 bg-orange-600 hover:bg-orange-700 text-white px-3 py-2 rounded-r-md"
      >
        <span className="flex items-center gap-1">
          <ArrowPathIcon className="h-5" />
          Reset
        </span>
      </button>
    </div>
  );
};

export default HoldReportSearchBarCP;
